import { useEffect, useState } from 'react';

import { useNavigate } from 'react-router-dom';
import { UseAlert } from '../../../presentation/hook/AlertHook';

import { ClinicUseCase } from '../../../data/useCase/ClinicUseCase';
import { PrivateRoutes } from '../../../main/constant/RouteConstant';

import EditClinicPage from '../../../presentation/page/editClinic/EditClinicPage';
import { HttpStatusCodeEnum } from '../../enums/HttpStatusCodeEnum';
import MessageConstant from '../../../main/constant/MessageConstant';
import { AddressUseCase } from '../../../data/useCase/AddressUseCase';
import { EndpointsConstant } from '../../../main/constant/EndpointConstant';

/**
 * EditClinicPageDomain - regra de negocio de clinica
 * @constructor
 */
export const EditClinicPageDomain: React.FC = () => {
  /**
   * Alertas
   */
  const { showAlert } = UseAlert();

  /**
   * navegacao da url
   */
  let navigate = useNavigate();

  /**
   * endpoint
   */
  const ENDPOINT_CLINIC = EndpointsConstant.clinic;

  /**
   * model
   */
  const [clinic, setClinic] = useState<null>(null);

  /**
   * saveClinic
   * @param params
   */
  const saveClinic = async (params: any) => {
    let model = {
      id: params.id,
      name: params.name,
      status: params.status ? params.status : 'A',
      tradeName: params.tradeName,
      accountType: params.accountType ? params.accountType : 'J',
      document_CNPJ: params.accountType === 'J' ? params.document_CNPJ : null,
      document_CPF: params.accountType === 'J' ? null : params.document_CPF,
      contact_Phone: params.contact_Phone,
      contact_Email: params.contact_Email,
      address_ZipCode: params.address_ZipCode,
      address_Street: params.address_Street,
      address_Number: params.address_Number,
      address_Complement: params.address_Complement,
      address_Neighborhood: params.address_Neighborhood,
      address_City: params.address_City,
      address_State: params.address_State,
      address_Country: params.address_Country,
      responsible_Name: params.responsible_Name ? params.responsible_Name : 'responsible_Name',
      responsible_Email: params.responsible_Email ? params.responsible_Email : params.contact_Email,
      responsible_Document_CRO: params.responsible_Document_CRO ? params.responsible_Document_CRO : 'responsible_Document_CRO',
      responsible_Document_RG: params.responsible_Document_RG ? params.responsible_Document_RG : 'responsible_Document_RG',
      responsible_Document_RG_IssuingAuthority: params.responsible_Document_RG_IssuingAuthority ? params.responsible_Document_RG_IssuingAuthority : 'SSP',
      setup_NumberOfChairs: params.setup_NumberOfChairs,
      setup_DentistAdmin: params.setup_DentistAdmin,
      setup_StandardAppointmentTime: params.setup_StandardAppointmentTime,
      setup_WeeklyWorkingHours: params.setup_WeeklyWorkingHours,
      setup_WeekDays: params.setup_WeekDays,
    };

    await new ClinicUseCase(`${ENDPOINT_CLINIC}/${params.id}`)
      .Put({
        data: model,
      })
      .then((response) => {
        console.info('RESPONSE: ', response);
        if (response.statusCode !== undefined) {
          if (response.statusCode === HttpStatusCodeEnum.ok) {
            showAlert({
              show: true,
              content: MessageConstant.sucesso.criar,
              color: 'success',
              time: 2000,
            });
          } else {
            response.body.forEach((item: any) => {
              showAlert({
                show: true,
                content: item.errorMessage,
                color: 'warning',
                time: 2000,
              });
            });
          }
        } else {
          showAlert({
            show: true,
            content: MessageConstant.erro.generico,
            color: 'danger',
            time: 2000,
          });
        }
      })
      .catch((error) => {
        console.error('ERRO: ', error);
        if (error.response.status === HttpStatusCodeEnum.badRequest) {
          error.response.data.forEach((item: any) => {
            showAlert({
              show: true,
              content: item.errorMessage,
              color: 'warning',
              time: 2000,
            });
          });
        } else {
          showAlert({
            show: true,
            content: MessageConstant.erro.generico,
            color: 'danger',
            time: 2000,
          });
        }
      });

    await getClinic();
  };

  /**
   * comeBack - voltar
   */
  const comeBack = () => {
    navigate(PrivateRoutes.HOME);
  };

  /**
   * getClinic
   */
  const getClinic = async () => {
    await new ClinicUseCase(`${ENDPOINT_CLINIC}`)
      .Get()
      .then((response) => {
        setClinic(response.body);
      })
      .catch((error) => {
        console.error('ERRO: ', error);
        if (error.response.status === HttpStatusCodeEnum.badRequest) {
          error.response.data.forEach((item: any) => {
            showAlert({
              show: true,
              content: item.errorMessage,
              color: 'warning',
              time: 2000,
            });
          });
        } else {
          showAlert({
            show: true,
            content: MessageConstant.erro.generico,
            color: 'danger',
            time: 2000,
          });
        }
      });
  };

  /**
   * inicia preenchendo a clinica
   */
  const init = async () => {
    await getClinic();
  };

  /**
   * inicio
   */
  useEffect(() => {
    init();
  }, []);

  /**
   * endpoint de endereço
   */
  const ENDPOINT_ADDRESS = EndpointsConstant.address;

  /**
   * model endereco
   */
  const [endereco, setEndereco] = useState<null>(null);

  const getAddress = async (cep: string) => {
    await new AddressUseCase(`${ENDPOINT_ADDRESS}/${cep}`)
      .Get()
      .then((response) => {
        console.info('RESPONSE: ', response);
        setEndereco(response.body);
      })
      .catch((error) => {
        console.error('ERRO: ', error);
      });
  };

  return (
    <>
      <EditClinicPage saveClinic={saveClinic} comeBack={comeBack} clinic={clinic} getAddress={getAddress} address={endereco} />
    </>
  );
};
